import {useState} from "react";
import {MultiSelect} from "react-multi-select-component";

const MultiselectDropdown = (props) => {

    const [selected, setSelected] = useState([]);

    const onValueChange = (e) => {
        setSelected(e);
        props.onSelectionChange(e);
    }

    return (
        <div>
            <h3 className="filter-header">{props.title}</h3>
            <MultiSelect
                options={props.options}
                value={selected}
                onChange={e => onValueChange(e)}
                labelledBy="Categories"
            />
        </div>
    );
};

export default MultiselectDropdown;